import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebase";

const userAuthContext = createContext()

export function UserAuthContextProvider({children}) {
    const [ user, setUser] = useState("")

    function logIn(email, password){
        return signInWithEmailAndPassword(auth, email, password)
    }
    function logOut(){
        return signOut(auth)
    }
    useEffect(() =>{
        const unsubsribe = onAuthStateChanged(auth,(currentUser) =>{
            setUser(currentUser)
            localStorage.setItem('isLoggedIn', currentUser);
        })

        return () => {
            unsubsribe()
        }
    },[])

    return (
        <userAuthContext.Provider value={{ user, logIn, logOut }}>
            {children}
        </userAuthContext.Provider>
    )
}

export function useUserAuth(){
    return useContext(userAuthContext)
}